import { HTMLAttributes } from 'react';
import styled, { css, DefaultTheme } from 'styled-components';

import { styles } from '../../styles';

const color = {
  white: css`
    color: white;
  `,
  primary: css`
    ${styles.color.primary};
  `,
  light: css`
    ${styles.color.textLight};
  `,
  danger: css`
    ${styles.color.danger};
  `,
};

export const Text = styled.span<
  {
    t?: keyof typeof color | null;
    size?: keyof DefaultTheme['fontSize'] | null;
    danger?: boolean;
  } & HTMLAttributes<HTMLSpanElement>
>`
  font-size: ${(props) => props.theme.fontSize[props.size || 'md']};
  ${(props) => (props.t ? color[props.t] : null)};
  ${(props) => (props.danger ? styles.color.danger : '')};
`;
